import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/**
 * StatusBadge: compact state pill, e.g. "Clocked in 6:48 am" in the header
 * or "Now" on the current stop.
 * Props:
 * - label (string)
 * - tone: 'success' | 'primary' | 'neutral' | 'warning' | 'danger'
 * - size: 'regular' (header) | 'small' (inside rows)
 * - style
 */
const StatusBadge = ({ label, tone = 'neutral', size = 'regular', style }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View
			style={[styles.badge, styles[size], styles[tone], style]}
			accessibilityRole="text"
			accessibilityLabel={label}
		>
			<Text style={[styles.label, styles[`${tone}Label`]]} numberOfLines={1}>{label}</Text>
		</View>
	);
};

const createStyles = ({ ui: { colors, radius, type } }) => ({
	badge: {
		alignSelf: 'flex-start',
		backgroundColor: colors.chip,
	},
	regular: {
		borderRadius: radius.chip,
		paddingVertical: 6,
		paddingHorizontal: 10,
	},
	small: {
		borderRadius: radius.tag,
		paddingVertical: 5,
		paddingHorizontal: 8,
	},
	label: {
		...type.label,
		color: colors.onChip,
	},
	neutral: {},
	neutralLabel: {},
	success: {
		backgroundColor: colors.successBg,
	},
	successLabel: {
		color: colors.onSuccessBg,
	},
	primary: {
		backgroundColor: colors.primary,
	},
	primaryLabel: {
		color: colors.onPrimary,
	},
	warning: {
		backgroundColor: colors.warningTagBg,
	},
	warningLabel: {
		color: colors.warning,
	},
	danger: {
		backgroundColor: colors.dangerSolid,
	},
	dangerLabel: {
		color: colors.onDangerSolid,
	},
});

export default StatusBadge;
